import {
  DropdownOptions,
  FilterProvider,
  Flex,
  LocalCashTables,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
} from "dash-ui";

import BlockBrokerModal from "pages/brokers/components/BlockBrokerModal/BlockBrokerModal";
import UnblockBrokerModal from "pages/brokers/components/UnblockBrokerModal/UnblockBrokerModal";

import BrokersTable from "./components/BrokersTable/BrokersTable";
import BrokersTopBar from "./components/BrokersTopBar/BrokersTopBar";
import DeleteBrokerModal from "./components/DeleteBrokerModal/DeleteBrokerModal";
import { AgentsTable } from "v2/components/agents-table";
import { SeekersTable } from "v2/components/seekers-table";

const BrokersPage = ({ isSeeker }: { isSeeker: boolean }) => {
  return (
    <PaginationProvider storageTableName={LocalCashTables.BROKERS}>
      <FilterProvider>
        <SearchProvider>
          <SortProvider>
            <ModalProvider>
              <Flex flex={1} w="100%" flexDirection="column">
                <DropdownOptions />
                {isSeeker ? <SeekersTable /> : <AgentsTable />}
                <BlockBrokerModal />
                <UnblockBrokerModal />
                <DeleteBrokerModal />
              </Flex>
            </ModalProvider>
          </SortProvider>
        </SearchProvider>
      </FilterProvider>
    </PaginationProvider>
  );
};

export default BrokersPage;
